import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import { useNotify } from 'react-admin'
import { usePriceModalContext } from '../../../../Utils/providers/PriceModalProvider'
import { useAdjustmentStatusContext } from '../../../../Utils/providers/AdjustmentStatusProvider'
import ConfirmationModal from './ConfirmationModal'
import ScrapModal from './ScrapModal'
import SalvageModal from './SalvageModal'
import BestPriceModal from './BestPriceModal'

const PriceModals = ({ sortedAdjustments }) => {
  const notify = useNotify()
  const { convertScrap, missingSections } = useAdjustmentStatusContext()
  const { activeModal, openModal } = usePriceModalContext()
  const previouslyMissing = useRef()

  useEffect(() => {
    if (!previouslyMissing.current) {
      previouslyMissing.current = missingSections
      return
    }

    const sectionCompleted = Object.keys(missingSections).some(
      (key) =>
        previouslyMissing.current[key] === true &&
        missingSections[key] === false
    )

    // Only open scrap modal if conversion needed AND no other modal is open
    if (sectionCompleted && convertScrap && !activeModal) {
      notify(
        'Lead should be converted to scrap due to offer price being less than scrap price, please continue scrap journey.',
        {
          type: 'error',
        }
      )
      openModal('scrap', { agent: convertScrap })
    }

    // Update reference to current missing sections for next comparison
    previouslyMissing.current = missingSections
  }, [missingSections])

  return (
    <>
      <ConfirmationModal />
      <ScrapModal />
      <SalvageModal />
      <BestPriceModal sortedAdjustments={sortedAdjustments} />
    </>
  )
}

PriceModals.propTypes = {
  sortedAdjustments: PropTypes.array,
}

export default PriceModals
